import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';

@Injectable({
  providedIn: 'root'
})
export class RequestsService {

  constructor(
    private angularFireDatabase: AngularFireDatabase
  ) { }
  createRequest(request){
    const emailClean = request.receiver_email.replace('.',',');
    return this.angularFireDatabase.object('requests/'+emailClean+'/'+request.sender).set(request);
  }
  setRequestStatus(request, status){
    const emailClean = request.receiver_email.replace('.',',');
    return this.angularFireDatabase.object('requests/'+emailClean+'/'+request.sender+'/status').set(status);
  }
  getRequestForEmail(email){
    const emailClean = email.replace('.',',');
    return this.angularFireDatabase.list('requests/'+emailClean);
  }
}
